"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _Modal = _interopRequireDefault(require("@material-ui/core/Modal"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Button = _interopRequireDefault(require("../Button"));

var _Video = _interopRequireDefault(require("../Video"));

var _MessageEditor = require("../MessageEditor");

var _styled = require("./styled");

var Lightbox = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Lightbox, _PureComponent);

  var _super = (0, _createSuper2["default"])(Lightbox);

  function Lightbox() {
    (0, _classCallCheck2["default"])(this, Lightbox);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Lightbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          media = _this$props.media,
          index = _this$props.index,
          isOpen = _this$props.isOpen,
          onToNext = _this$props.onToNext,
          onToPrevious = _this$props.onToPrevious,
          hasNext = _this$props.hasNext,
          hasPrevious = _this$props.hasPrevious,
          onClose = _this$props.onClose,
          onKeyPress = _this$props.onKeyPress;
      var mediaToShow = media[index];
      return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
        open: isOpen
      }, /*#__PURE__*/_react["default"].createElement(_styled.Wrapper, {
        onKeyDown: onKeyPress
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "column",
        wrap: "nowrap"
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        container: true,
        justify: "flex-end"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        id: "lightbox-close-button",
        light: true,
        onClick: onClose,
        icon: true,
        flat: true,
        licorice: true
      }, /*#__PURE__*/_react["default"].createElement(_styled.CloseIcon, null))), /*#__PURE__*/_react["default"].createElement(_styled.NavigationWrapper, {
        item: true,
        container: true,
        alignItems: "center",
        justify: "center",
        wrap: "nowrap"
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 1,
        container: true,
        justify: "center"
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true
      }, hasPrevious(index) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        id: "lightbox-previous-button",
        onClick: onToPrevious,
        icon: true,
        flat: true,
        licorice: true
      }, /*#__PURE__*/_react["default"].createElement(_styled.ChevronLeftIcon, null)))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 10,
        container: true,
        justify: "center"
      }, mediaToShow.type === _MessageEditor.MESSAGE_MEDIA_TYPES.IMAGE && /*#__PURE__*/_react["default"].createElement(_styled.Image, {
        src: mediaToShow.src,
        alt: "lightbox"
      }), mediaToShow.type === _MessageEditor.MESSAGE_MEDIA_TYPES.VIDEO && /*#__PURE__*/_react["default"].createElement(_styled.VideoContainer, null, /*#__PURE__*/_react["default"].createElement(_Video["default"], {
        poster: mediaToShow.poster,
        src: mediaToShow.src
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 1,
        container: true,
        justify: "center"
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true
      }, hasNext(index) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        id: "lightbox-next-button",
        onClick: onToNext,
        icon: true,
        flat: true,
        licorice: true
      }, /*#__PURE__*/_react["default"].createElement(_styled.ChevronRightIcon, null))))))));
    }
  }]);
  return Lightbox;
}(_react.PureComponent);

exports["default"] = Lightbox;